import axios from "axios";
import { SET_ERROR, ANNUAL_BILLING_SETTINGS } from "../../types";
import ToastMessage from "../../../components/toast";

export const getAnnualBillingSettings = () => {
    return async (dispatch) => {
        await axios.get('api/annual-billing/report-settings')
            .then(response => {
                dispatch({
                    type: ANNUAL_BILLING_SETTINGS,
                    payload: response.data
                });
            }).catch(
                e => {
                    dispatch({
                        type: SET_ERROR,
                        payload: {
                            e, error: true
                        }
                    });
                });
    };
};

export const saveAnnualBillingSettings = (payload) => {
    return async (dispatch) => {
        await axios.post('api/annual-billing/update-settings', payload).then(response => {
            dispatch({
                type: ANNUAL_BILLING_SETTINGS,
                payload: response.data
            });
            ToastMessage("Saved!", "success");
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            });
            ToastMessage(e.message, "error");
        });
    };
};


